import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Imgix from 'react-imgix';
import breakpoints from '@/constants/breakpoints';
import ArrowTwo from '../../common/ArrowTwo';

export default function BestSellers() {
  const baseImgURL = 'https://theinside.imgix.net/homepage/rebrand';
  const imgExtension = '.jpg';
  const imgName = 'theinside_HP_dreambedroomimage';

  return (
    <Container>
      <div className="image-container">
        <Imgix
          className="image"
          src={`${baseImgURL}/${imgName}${imgExtension}`}
          imgixParams={{ auto: 'compress,format' }}
          htmlAttributes={{
            loading: 'lazy',
            alt: 'best sellers'
          }}
        />
      </div>
      <div className="text-container">
        <Title>
          <em>Cozy Up</em>
        </Title>
        <Copy>Your Dream Bedroom </Copy>
        <Link className="link" to="/collections/the-bedroom-edit">
          Shop Now <ArrowTwo width={25} height={25} />
        </Link>
      </div>
    </Container>
  );
}

const Container = styled.div`
  padding: 32px 32px 40px;
  background-color: ${props => props.theme.colors.oatmilk};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: ${breakpoints['tablet']}px) {
    flex-direction: row-reverse;
    padding: 37px;
    padding-right: 45px;
  }

  @media (min-width: ${breakpoints['xlarge-desktop']}px) {
    padding: 86px 121px;
  }

  .image-container {
    flex: 1;
    margin-bottom: 34px;
  }

  .image {
    width: 100%;
  }

  .text-container {
    flex: 1;
    text-align: center;

    @media (min-width: ${breakpoints['tablet']}px) {
      text-align: left;
      padding-left: 52.3px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .link {
      font-size: 16px;
      color: ${props => props.theme.colors.mud};

      @media (min-width: ${breakpoints['desktop']}px) {
        font-size: 20px;
      }

      svg {
        path {
          stroke: ${props => props.theme.colors.mud};
        }
      }
    }
  }
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.secondary.family};
  letter-spacing: ${({ theme }) => theme.old ? '-0.36px' : theme.fonts.secondary.letterSpacing};
  font-weight: 300;
  font-size: 18px;
  line-height: 1;
  text-align: center;
  margin-bottom: 10px;
  color: ${props => props.theme.colors.mud};

  @media (min-width: ${breakpoints['tablet']}px) {
    text-align: left;
    margin-bottom: 13px;
  }

  @media (min-width: ${breakpoints['desktop']}px) {
    font-size: 26px;
    line-height: 1.23;
    letter-spacing: -0.52px;
    margin-bottom: 16px;
  }

  @media (min-width: ${breakpoints['large-desktop']}px) {
    font-size: 32px;
    line-height: 1;
    letter-spacing: -0.64px;
    margin-bottom: 27px;
  }
`;

const Copy = styled.p`
  font-size: 26px;
  line-height: 32px;
  letter-spacing: -0.52px;
  margin-bottom: 18px;
  color: ${props => props.theme.colors.mud};
  font-family: ${({ theme }) => theme.fonts.secondary.family};
    letter-spacing: ${({ theme }) => theme.fonts.secondary.letterSpacing};
  font-weight: 300;

  @media (min-width: ${breakpoints['desktop']}px) {
    font-size: 44px;
    line-height: 56px;
    letter-spacing: -0.88px;
    margin-bottom: 31.3px;
  }

  @media (min-width: ${breakpoints['large-desktop']}px) {
    font-size: 56px;
    line-height: 65px;
    letter-spacing: -1.12px;
    margin-bottom: 43.5px;
  }
`;
